import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './globals.css';
import './admin/AdminPage.css';
import './admin/FileList.css';
import './admin/LoginPage.css';
import './admin/ScheduleEditor.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initGA } from './utils/analytics';

initGA(); // Initialize Google Analytics

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register({
  onUpdate: () => {
    // Silent: do not prompt or auto-reload here. A new version stays parked in
    // "waiting" until the kiosk's build-number watcher activates it through
    // safeReload(), which only swaps once everything is fully downloaded.
    console.log('A new version has been downloaded and is ready to activate.');
  },
});
